export default __webpack_public_path__ + "transfix-maps/icons/P5.196a9d459a8efc041ba1b62ff26ba07a.png";